<div [className]="collapse == true ? 'input-wrapper collapsed-side-form' : 'input-wrapper'">

  <div class="side-info-table">

    <sem-loader [showLoader]="showLoader"></sem-loader>

    <div class="side-wrapper edit-form-title-wrapper">
      <p class="input-form-title">{{translationsService.translate(title)}}</p>
    </div>
  </div>

  <div class="l-cont-separator n-m"></div>

  <div class="mes-input-wrapper">
    <textarea [ngClass]="{ 'err-border': message.length > 0}" [(ngModel)]="inputMessageValue"
    [placeholder]="inputPlaceholder"></textarea>

    <!--div class="file-add-img" *ngIf="fileUploadEnabled">
    <img src="../../../../assets/css/images/platform/icon-attachment@3x.png" *ngIf="!file" />
    <img src="../../../../assets/css/images/platform/icon-attachment-added@3x.png" (click)="file = null"
      *ngIf="file" />
      <input class="file-section-add" #fileUpload id="fileUpload" type="file" *ngIf="!file"
        (change)="onFileChange($event)" title=" " />
      </div-->
      <p class="send" (click)="addMessage()">POŠLJI</p>
      <!--img src="../../../../assets/css/images/platform/icon-send@3x.png" (click)="addMessage()" /-->
    </div>

    <div>
      <div class="msg-attach">


        <div>
          <!-- add-attachment-button.component.html -->
          @if (file) {
            <img height="15" src="../../../../assets/css/images/platform/icon-attachment@3x.png" />
            <p class="f-n messenger-attachment-title" (click)="openFileExporer(file)">{{file.Name}}</p>
            <img class="rm-fi" height="15" src="../../../../assets/css/images/platform/remove-file@3x.png" (click)="file = null" />
          }
        </div>
        <div>

          <!-- file-upload.component.html -->
          @if (fileUploadEnabled) {
            <div class="file-upload-wrapper-msg">
              <input type="file" id="fileUpload" #fileUpload class="file-section-add"
                (change)="onFileChange($event)" title=" " hidden />
                <label for="fileUpload" class="file-upload-button">
                  <img src="../../../../assets/css/images/platform/icon-attachment@3x.png" height="15" /> Dodaj
                  priponko
                </label>
              </div>
            }
          </div>
        </div>

        @if (message.length > 0) {
          <div class="mess-error">
            <p>{{this.message}}</p>
          </div>
        }

        <div class="l-cont-separator idkw"></div>

        <div class="messages">
          @for (item of getMessages(); track item.Id) {

            @if ((item.Id && item.User && item.User.UserId == restProviderService.currentUser.Id) || !item.Id) {
              <div class="message"
                >
                <div class="text-info">
                    <p>Vi</p>
                    <p>{{item.Date | date : "dd.MM.yyyy HH:mm"}}</p>
                </div>
                <div class="text-container">
                    <p class="msg-body" [innerHTML]="item.MessageText | semLinkify"></p>
                    <!--img *ngIf="!item.Id" src="../../../../assets/css/images/platform/remove-file@3x.png"
                    class="remove-message" (click)="removeMessage(item)" /-->
                </div>
                @if (item.FileName) {
                  <div class="mes-file">
                    <img src="../../../../assets/css/images/platform/icon-attachment@3x.png" />
                    <p class="messenger-attachment-title" (click)="openFileExplorerExisting(item.FileName)">{{item.FileName}}</p>
                  </div>
                }
              </div>
            }

            @if (item.Id && item.User && item.User.UserId != restProviderService.currentUser.Id) {
              <div class="message mes-right"
                >
                <div class="text-info">
                    <p>{{item.Date | date : "dd.MM.yyyy HH:mm"}}</p>
                    <p>{{item.User.FullName}}</p>
                </div>
                <div class="text-container">
                    <p class="msg-body" [innerHTML]="item.MessageText | semLinkify"></p>
                </div>
                @if (item.FileName) {
                  <div class="mes-file">
                    <img src="../../../../assets/css/images/platform/icon-attachment@3x.png" />
                    <p class="messenger-attachment-title" (click)="openFileExplorerExisting(item.FileName)">{{item.FileName}}</p>
                  </div>
                }
              </div>
            }
          }
        </div>

      </div>